module.exports = __webpack_public_path__ + "2a50552414bb1ccb3d9487e1fbd0b671.pdf";